import ReferTo from '~/components/pages/ai/ai-form/ReferTo'
import { ReferToScrollKeyEnum, SpellAnalysisImgType } from '~/graphqls/types'
import { referToStyleAtom, referToRoleAtom, referToStructureAtom } from './atom'
import { useAtom } from 'jotai'
import { useType } from '../useType'
import useOptions from '../ai-form/useOptions'

const ReferToGroup = () => {
  const { isMJ, isMJ6, isMJ7 } = useType()
  const { isSdxl } = useOptions()

  const [referToRole, setReferToRole] = useAtom(referToRoleAtom)
  const [referToStyle, setReferToStyle] = useAtom(referToStyleAtom)
  const [referToStructure, setReferToStructure] = useAtom(referToStructureAtom)

  if (isMJ6) {
    return (
      <>
        <ReferTo
          scrollId={ReferToScrollKeyEnum.mjReferToStyle}
          radioKey={SpellAnalysisImgType.STYLE}
          formLabel="风格参考"
          formNotice="您可以上传一张图用作风格参考，生成的创作在美学和氛围上将和风格参考图接近"
          weightTitle="参考强度"
          weightNotice="参考强度(style weight)值越高，生成的创作风格越接近风格参考图"
          url={referToStyle.url}
          setUrl={url => {
            setReferToStyle({
              ...referToStyle,
              url,
            })
          }}
          weight={referToStyle.mjWeight}
          setWeight={mjWeight => {
            setReferToStyle({
              ...referToStyle,
              mjWeight,
            })
          }}
          min={0}
          max={1000}
          step={1}
        />
        <div className="h-5" />
        <ReferTo
          scrollId={ReferToScrollKeyEnum.mjReferToRole}
          radioKey={SpellAnalysisImgType.FACEID}
          formLabel="角色参考"
          formNotice="提供一个角色参考图像，AI生成的新人物画像在面部、发型、服装等方面与参考图像保持高度一致性"
          weightTitle="参考强度"
          weightNotice="参考强度（cref）为100时，会同时参考使用图像的脸部、头发和衣服；当参考强度为0时，它只会关注脸部（适合更换服装/头发等）"
          url={referToRole.url}
          setUrl={url => {
            setReferToRole({
              ...referToRole,
              url,
            })
          }}
          weight={referToRole.mjWeight}
          setWeight={mjWeight => {
            setReferToRole({
              ...referToRole,
              mjWeight,
            })
          }}
          min={0}
          max={100}
          step={1}
        />
      </>
    )
  } else if (isMJ7) {
    return (
      <>
        <ReferTo
          scrollId={ReferToScrollKeyEnum.mjReferToStyle}
          radioKey={SpellAnalysisImgType.STYLE}
          formLabel="风格参考"
          formNotice="您可以上传一张图用作风格参考，生成的创作在美学和氛围上将和风格参考图接近"
          weightTitle="参考强度"
          weightNotice="参考强度(style weight)值越高，生成的创作风格越接近风格参考图"
          url={referToStyle.url}
          setUrl={url => {
            setReferToStyle({
              ...referToStyle,
              url,
            })
          }}
          weight={referToStyle.mjWeight}
          setWeight={mjWeight => {
            setReferToStyle({
              ...referToStyle,
              mjWeight,
            })
          }}
          min={0}
          max={1000}
          step={1}
        />
      </>
    )
  }
  if (!isMJ && isSdxl) {
    return (
      <>
        <ReferTo
          scrollId={ReferToScrollKeyEnum.referToStyle}
          radioKey={SpellAnalysisImgType.STYLE}
          formLabel="风格参考"
          formNotice="您可以上传一张图用作风格参考，生成的创作在美学和氛围上将和风格参考图接近"
          weightTitle="参考强度"
          weightNotice="参考强度值越高，生成创作的风格越接近风格参考图"
          url={referToStyle.url}
          setUrl={url => {
            setReferToStyle({
              ...referToStyle,
              url,
            })
          }}
          weight={referToStyle.weight}
          setWeight={weight => {
            setReferToStyle({
              ...referToStyle,
              weight,
            })
          }}
          min={0}
          max={4}
          step={0.1}
          precision={1}
        />
        <div className="h-5" />
        <ReferTo
          scrollId={ReferToScrollKeyEnum.referToRole}
          radioKey={SpellAnalysisImgType.FACEID}
          formLabel="角色参考"
          formNotice="提供一个角色参考图像，AI生成的新人物画像在面部、发型、服装等方面与参考图像保持高度一致性"
          weightTitle="参考强度"
          weightNotice="参考强度值越高，生成创作的脸部、头发和衣服越接近角色参考图"
          url={referToRole.url}
          setUrl={url => {
            setReferToRole({
              ...referToRole,
              url,
            })
          }}
          weight={referToRole.weight}
          setWeight={weight => {
            setReferToRole({
              ...referToRole,
              weight,
            })
          }}
          min={0}
          max={2}
          step={0.1}
          precision={1}
          showPulidMode
          pulidMode={referToRole.pulidMode}
          setPulidMode={pulidMode => {
            setReferToRole({
              ...referToRole,
              pulidMode,
            })
          }}
        />
        <div className="h-5" />
        <ReferTo
          scrollId={ReferToScrollKeyEnum.referToStructure}
          radioKey={SpellAnalysisImgType.COMPOSITION}
          formLabel="结构参考"
          formNotice="您可以上传一张图用作结构参考，生成的创作将捕捉结构参考图的画面构图和空间结构"
          weightTitle="参考强度"
          weightNotice="参考强度值越高，生成创作的构图和风格越接近结构参考图"
          url={referToStructure.url}
          setUrl={url => {
            setReferToStructure({
              ...referToStructure,
              url,
            })
          }}
          weight={referToStructure.weight}
          setWeight={weight => {
            setReferToStructure({
              ...referToStructure,
              weight,
            })
          }}
          min={0}
          max={2}
          step={0.1}
          precision={1}
        />
        <div className="h-5" />
      </>
    )
  }
  return null
}
export default ReferToGroup
